import React from 'react'
import { renderers } from './FieldDefinitions'
import styles from './RenderedField.module.css'
import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { BuilderContext } from '../store/store.Builder'
import { Button } from 'antd'
import EditableLabel from '../../../../components/EditableLabel/EditableLabel'
import EditableDescription from '../../../../components/EditableDescription/EditableDescription'
import { closestCenter } from '@dnd-kit/core'
import { toJS } from 'mobx'

function getRenderer(type) {
  const renderer = renderers[type]

  if (!renderer) {
    console.error(`No renderer found for ${type}`)
    return null // ou retournez une valeur par défaut ou un autre comportement de repli
  }

  return renderer
}

const RenderedField = observer((props) => {
  const builderContext = useContext(BuilderContext)
  const { field, index, listeners, control, overlay, ...rest } = props

  const isASubField = field.isASubField
  const showHandleAndBar = !isASubField

  const fieldStyle = {
    ...field.design,
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  }

  const barStyle = {
    width: 'auto',
    height: '50px',
    backgroundColor: '#FFF',
    position: 'absolute',
    paddingLeft: '10px',
    paddingRight: '10px',
    top: '-65px',
    padding: '0 4px',
    gap: '8px',
    zIndex: '1000',
    boxShadow:
      '0 0 0 1px rgba(64, 87, 109, .07), 0 2px 12px rgba(53, 71, 90, .2)',
    left: '0',
    display:
      showHandleAndBar &&
      builderContext.selectedField?.id === field.id &&
      builderContext.isBarButtonVisible
        ? 'flex'
        : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '3px',
  }

  const handleStyle = {
    position: 'absolute',
    right: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2, // pour que le bouton soit au-dessus du champ
  }

  const handleClick = (event) => {
    if (event.target !== event.currentTarget) {
      return
    }
    console.log('Clic dans RenderedField')
    console.log('clique sur', toJS(field))
    try {
      builderContext.setSelectedField({ ...field }, 'field')
    } catch (error) {
      console.error(
        'Error in RenderedField in setSelectedField:',
        error.message
      )
    }
  }

  const Component = getRenderer(field.type, field)

  const className = `${styles['canvas-field']} ${
    overlay ? styles.overlay : ''
  } ${
    builderContext.selectedField?.id === field.id &&
    builderContext.selectedField?.typeSelected === 'field'
      ? 'selected__item'
      : ''
  }`

  return (
    <div style={{ position: 'relative' }}>
      <div style={barStyle} className={styles.container__actions__buttons}>
        {index > 0 && (
          <div
            className="up-button"
            onClick={() => builderContext.handleMoveField(index, index - 1)}
          >
            <div className={styles.button_container_action}>
              <div className={styles.container_svg_button}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12.75 5.82v8.43a.75.75 0 1 1-1.5 0V5.81L8.99 8.07A.75.75 0 1 1 7.93 7l2.83-2.83a1.75 1.75 0 0 1 2.47 0L16.06 7A.75.75 0 0 1 15 8.07l-2.25-2.25zM15 10.48l6.18 3.04a1 1 0 0 1 0 1.79l-7.86 3.86a3 3 0 0 1-2.64 0l-7.86-3.86a1 1 0 0 1 0-1.8L9 10.49v1.67L4.4 14.4l6.94 3.42c.42.2.9.2 1.32 0l6.94-3.42-4.6-2.26v-1.67z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        )}
        {index < builderContext.fields.length - 1 && (
          <div
            className="down-button"
            onClick={() => builderContext.handleMoveField(index, index + 1)}
          >
            <div className={styles.button_container_action}>
              <div className={styles.container_svg_button}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12.75 18.12V9.75a.75.75 0 0 0-1.5 0v8.37l-2.26-2.25a.75.75 0 0 0-1.06 1.06l2.83 2.82c.68.69 1.79.69 2.47 0l2.83-2.82a.75.75 0 0 0-1.06-1.06l-2.25 2.25zM15 11.85v1.67l6.18-3.04a1 1 0 0 0 0-1.79l-7.86-3.86a3 3 0 0 0-2.64 0L2.82 8.69a1 1 0 0 0 0 1.8L9 13.51v-1.67L4.4 9.6l6.94-3.42c.42-.2.9-.2 1.32 0L19.6 9.6 15 11.85z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        )}
        <div
          className="duplicate-button"
          onClick={() => builderContext.handleDuplicate(field.id)}
          title="Dupliquer"
        >
          <div className={styles.button_container_action}>
            <div className={styles.container_svg_button}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5 3h8a2 2 0 0 1 2 2v.5h-1.5V5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2.5V17H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm6 5.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5h-8ZM19 7h-8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z"
                  fill="currentColor"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15 11a.75.75 0 0 0-.75.75v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5A.75.75 0 0 0 15 11Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div onClick={() => builderContext.handleDeleteField(field.id)}>
          <div className={styles.button_container_action}>
            <div className={styles.container_svg_button}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M8 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3h4.25a.75.75 0 1 1 0 1.5H19V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6.5H3.75a.75.75 0 0 1 0-1.5H8zM6.5 6.5V18c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.5h-11zm3-1.5h5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm-.25 4h1.5v8h-1.5V9zm4 0h1.5v8h-1.5V9z"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={handleClick}
        className={className}
        id={field.id}
        style={fieldStyle}
      >
        <div className="main__container__field">
          {field.type !== 'divider' && (
            <>
              <EditableLabel field={field} />
              {field.descriptionVisible && (
                <EditableDescription field={field} />
              )}
            </>
          )}

          <div
            onClick={(e) => builderContext.handleClickOnInput(e, field)}
            className={`container__input__fields ${
              builderContext.selectedField?.id === field.id &&
              builderContext.selectedField?.typeSelected === 'input'
                ? 'selected__item'
                : ''
            }`}
          >
            <Component field={field} {...rest} />
          </div>
        </div>
      </div>
    </div>
  )
})

export default RenderedField
